<template>
  <div class="home">
    <div class="welcome">
      <img class="banner" src="../assets/home_banner.png" />
      <div class="welcome-text">
        <div class="welcome-title">
          <img class="welcome-title-logo" src="../assets/banner_logo.png" />
          <span class="welcome-title-text">{{
            $t("Welcome to ACOrange")
          }}</span>
        </div>
        <div class="welcome-content">
          <div class="welcome-content-item">
            <span class="white-dot"></span>
            {{
              $t(
                "ACOrange is the largest private performance enterprise in China."
              )
            }}
          </div>
          <div class="welcome-content-item">
            <span class="white-dot"></span>
            {{
              $t(
                "We apply strategic planning to cover all segments of perfomance industry."
              )
            }}
          </div>
          <div class="welcome-content-item">
            <span class="white-dot"></span>
            {{ $t("Our content covers all performance genres.") }}
          </div>
          <div class="welcome-content-item">
            <span class="white-dot"></span>
            {{
              $t(
                "Top-rank market share of Family Show, Pop Music Live Concert, Musical and many other sectors"
              )
            }}
          </div>
          <div class="welcome-content-item">
            <span class="white-dot"></span>
            {{
              $t(
                "We are the first Chinese Corporation investing in Broadway musicals."
              )
            }}
          </div>
          <router-link class="welcome-about-us" to="/about-us/brief">
            {{ $t("About Us")
            }}<i class="iconfont acog-gengduo welcome-about-us-arrow"></i>
          </router-link>
        </div>
      </div>
    </div>
    <div class="products">
      <div class="products-title">{{ $t("Production & Presentation") }}</div>
      <div class="products-content">
        <div class="product">
          <img class="product-img" src="../assets/poster_1.png" />
          <div class="product-name">{{ $t("CATS") }}</div>
          <span class="product-arrow"></span>
        </div>
        <div class="product">
          <img class="product-img" src="../assets/poster_2.png" />
          <div class="product-name">
            <span class="product-arrow"></span>
            {{ $t("WESTLIFE THE TWENTY TOUR") }}
          </div>
        </div>
        <div class="product">
          <img class="product-img" src="../assets/poster_3.png" />
          <div class="product-name">
            <span class="product-arrow"></span>
            {{ $t("CIRQUE DU SOLEIL OVO") }}
          </div>
        </div>
        <div class="product">
          <img class="product-img" src="../assets/poster_4.png" />
          <div class="product-name">
            <span class="product-arrow"></span>
            {{ $t("HYDE WORLD TOUR 2019 ...") }}
          </div>
        </div>
        <div class="product">
          <img class="product-img" src="../assets/poster_5.png" />
          <div class="product-name">
            <span class="product-arrow"></span>
            {{ $t("Urban Drama Festival") }}
          </div>
        </div>
      </div>
      <router-link class="more-products" to="/productions">
        {{ $t("Read More")
        }}<i class="iconfont acog-gengduo more-products-arrow"></i>
      </router-link>
    </div>
    <div class="theatres">
      <div class="theatres-title">Theatres</div>
      <i class="iconfont acog-zuojiantou theatres-left-arrow" @click="onTheatresLeftClick"></i>
      <div class="theatres-content" ref="threatres">
        <div
          class="theatre"
          :class="{ 'first-theatre': index === 0 }"
          v-for="(theatre, index) in theatres"
          :key="index"
          :style="{ backgroundColor: bgColorArray[index % 5] }"
        >
          <img class="theatre-img" :src="theatre.img" />
          <div class="theatre-name">{{ theatre.name }}</div>
          <div class="theatre-city">{{ theatre.city }}</div>
        </div>
      </div>
      <i class="iconfont acog-youjiantou theatres-right-arrow" @click="onTheatresRightClick"></i>
    </div>
    <Achievement></Achievement>
    <div class="strategic">
      <div class="strategic-left">
        <div class="strategic-left-info">
          <div class="strategic-left-info-title">Strategic Layout</div>
          <div class="strategic-left-info-desc strategic-left-info-desc-first">
            Covering the whole industry chain of performance
          </div>
          <div class="strategic-left-info-desc strategic-left-info-desc-second">
            Content of all kinds of performance
          </div>
          <LayoutBubble class="strategic-left-info-bubble"></LayoutBubble>
          <div class="strategic-left-info-more" @click="visible.strategicLayoutDialog=true">
            Read More<i
              class="iconfont acog-gengduo strategic-left-info-more-arrow"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <StrategicLayoutDialog v-if="visible.strategicLayoutDialog" @close="visible.strategicLayoutDialog=false"></StrategicLayoutDialog>
  </div>
</template>

<script>
import LayoutBubble from "../components/LayoutBubble";
import Footer from "../components/Footer";
import Achievement from "../components/Achievement";
import StrategicLayoutDialog from "../components/StrategicLayoutDialog"
export default {
  name: "home",
  data() {
    return {
      bgColorArray: ["#0C2266", "#5C118B", "#7F3259", "#347FC4", "#2A9392"],
      theatres: [],
      visible:{
        strategicLayoutDialog: false
      }
    };
  },
  mounted() {
    this.theatres = [
      {
        img: require("../assets/theater_round_1.png"),
        name: this.$t("Nanshan Cultural and Sports Center"),
        city: this.$t("Shenzhen,China")
      },
      {
        img: require("../assets/theater_round_2.png"),
        name: this.$t("Shijiazhuang Grand Theatre"),
        city: this.$t("Shijiazhuang,China")
      },
      {
        img: require("../assets/theater_round_3.png"),
        name: this.$t("Putuo Grand Theatre"),
        city: this.$t("Zhoushan,China")
      },
      {
        img: require("../assets/theater_round_4.png"),
        name: this.$t("Tianyuan Arts Centre of Wuyishan New Area"),
        city: this.$t("Nanping,China")
      },
      {
        img: require("../assets/theater_round_5.png"),
        name: this.$t("Yinshanhu Grand Theatre of Suzhou"),
        city: this.$t("Suzhou,China")
      },
      {
        img: require("../assets/theater_round_5.png"),
        name: this.$t("Yinshanhu Grand Theatre of Suzhou"),
        city: this.$t("Suzhou,China")
      },
      {
        img: require("../assets/theater_round_6.png"),
        name: this.$t("Gu’an Grand Theatre"),
        city: this.$t("Langfang,China")
      },
      {
        img: require("../assets/theater_round_7.png"),
        name: this.$t("Yaohai  Grand Theatre of Hefei"),
        city: this.$t("Hefei,China")
      },
      {
        img: require("../assets/theater_round_8.png"),
        name: this.$t("Ulan Muqir Palace Grand Theatre"),
        city: this.$t("Xing'an League,China")
      },
      {
        img: require("../assets/theater_round_9.png"),
        name: this.$t("Xinqiao Culture Arts Centre of Shenzhen"),
        city: this.$t("Shenzhen,China")
      },
      {
        img: require("../assets/theater_round_10.png"),
        name: this.$t("Suzhou Kunqu Opera Theatre of Jiangsu"),
        city: this.$t("Shenzhen,China")
      },
      {
        img: require("../assets/theater_round_11.png"),
        name: this.$t("Chongqing Culture Palace Grand Theatre"),
        city: this.$t("Chongqing,China")
      },
      {
        img: require("../assets/theater_round_12.png"),
        name: this.$t("Agile Clearwater Bay Arts Centre"),
        city: this.$t("Lingshui,China")
      },
      {
        img: require("../assets/theater_round_13.png"),
        name: this.$t("The Marionette Theatre Of Quanzhou"),
        city: this.$t("Quanzhou,China")
      },
      {
        img: require("../assets/theater_round_14.png"),
        name: this.$t("Shanghai ‘KE’ Contemporary Arts Centre"),
        city: this.$t("Shanghai,China")
      },
      {
        img: require("../assets/theater_round_15.png"),
        name: this.$t("Yichang Theatre"),
        city: this.$t("Yichang,China")
      },
      {
        img: require("../assets/theater_round_16.png"),
        name: this.$t("Guangzhou TaiGuCang Wharf"),
        city: this.$t("Guangzhou,China")
      },
      {
        img: require("../assets/theater_round_17.png"),
        name: this.$t("Ninghai Culture Complex"),
        city: this.$t("Ninghai,China")
      },
      {
        img: require("../assets/theater_round_18.png"),
        name: this.$t("Liu Gang Culture Center"),
        city: this.$t("Liuzhou,China")
      }
    ];
  },
  methods:{
    onTheatresLeftClick(){
      this.$refs.threatres.scrollLeft= this.$refs.threatres.scrollLeft-260;
    },
    onTheatresRightClick(){
      this.$refs.threatres.scrollLeft= this.$refs.threatres.scrollLeft+260;
    }
  },
  components: {
    LayoutBubble,
    Achievement,
    StrategicLayoutDialog,
    Footer,
  }
};
</script>
<style lang="scss" scoped>
.welcome {
  background: #810b13;
  height: 808px;
  overflow: hidden;
  position: relative;
  text-align: center;
}
.banner {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: block;
  width: 1920px;
}
.welcome-text {
  position: relative;
  text-align: center;
}
.welcome-title {
  margin-top: 175px;
}
.welcome-title-logo {
  vertical-align: middle;
}
.welcome-title-text {
  margin-left: 27px;
  font-size: 50px;
  color: #fefefe;
  height: 80px;
  line-height: 80px;
  display: inline-block;
  vertical-align: middle;
}
.white-dot {
  width: 8px;
  height: 8px;
  background: rgba(218, 218, 218, 1);
  border-radius: 50%;
  display: inline-block;
  margin-right: 26px;
}
.welcome-content {
  margin-top: 123px;
  width: 1200px;
  display: inline-block;
  text-align: left;
}
.welcome-content-item {
  color: #fefefe;
  font-size: 22px;
  height: 24px;
  margin-top: 30px;
}
.welcome-about-us {
  width: 232px;
  height: 46px;
  line-height: 46px;
  border: 1px solid rgba(255, 144, 0, 1);
  border-radius: 23px;
  color: #ff9900;
  font-size: 20px;
  margin-left: 35px;
  margin-top: 45px;
  text-align: center;
  cursor: pointer;
  vertical-align: middle;
  &-arrow {
    font-size: 10px;
    margin-left: 2px;
    vertical-align: middle;
  }
}
.products {
  background-color: #f2f2f2;
  padding-top: 59px;
  text-align: center;
}
.products-title {
  font-size: 40px;
  font-weight: bold;
  color: rgba(46, 41, 37, 1);
  height: 33px;
  text-align: center;
}
.products-content {
  margin-top: 50px;
  white-space: nowrap;
}
.product {
  width: 20%;
  min-width: 240px;
  display: inline-block;
  border: 1px solid rgba(222, 222, 222, 1);
  box-sizing: border-box;
  position: relative;
}

.product-img {
  width: 100%;
  display: block;
}
.product-name {
  height: 70px;
  line-height: 70px;
  color: #2e2925;
  font-size: 24px;
  font-weight: 400;
  padding: 0 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.product-arrow {
  position: absolute;
  border-width: 15px 12px;
  border-style: solid;
  border-color: transparent transparent #f2f2f2 transparent;
  top: -30px;
  left: 16px;
  bottom: 70px;
}
.more-products {
  width: 232px;
  height: 46px;
  border: 1px solid rgba(236, 105, 0, 1);
  border-radius: 23px;
  color: rgba(236, 105, 0, 1);
  line-height: 46px;
  text-align: center;
  display: inline-block;
  margin-top: 85px;
  margin-bottom: 50px;
  cursor: pointer;
  vertical-align: middle;
  &-arrow {
    margin-left: 2px;
    font-size: 10px;
    vertical-align: middle;
  }
}
.theatres {
  background-color: #fefefe;
  text-align: center;
  &-title {
    text-align: center;
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(46, 41, 37, 1);
    height: 33px;
    line-height: 33px;
    margin-top: 58px;
  }
  &-left-arrow {
    width: 28px;
    height: 54px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.2;
    display: inline-block;
    vertical-align: middle;
    border-radius: 28px 0 0 28px;
    text-align: center;
    cursor: pointer;
    font-size: 17px;
    color: #fefefe;
    line-height: 54px;
    vertical-align: middle;
  }
  &-right-arrow {
    width: 28px;
    display: inline-block;
    height: 54px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.2;
    vertical-align: middle;
    border-radius: 0 28px 28px 0;
    text-align: center;
    cursor: pointer;
    font-size: 17px;
    color: #fefefe;
    line-height: 54px;
    vertical-align: middle;
  }
  &-content {
    vertical-align: middle;
    margin-top: 50px;
    margin-bottom: 60px;
    width: 1200px;
    overflow-x: hidden;
    white-space: nowrap;
    display: inline-block;
    .theatre {
      width: 240px;
      height: 380px;
      overflow: hidden;
      display: inline-block;
      margin-left: 20px;
      &-img {
        margin-top: 20px;
        margin-left: 82px;
      }
      &-name {
        margin-top: 22px;
        text-align: left;
        padding: 0 24px;
        font-size: 22px;
        font-weight: 400;
        height: 60px;
        color: rgba(255, 255, 255, 1);
        white-space: normal;
        overflow: hidden;
      }
      &-city {
        height: 18px;
        line-height: 18px;
        font-size: 18px;
        font-weight: 300;
        color: rgba(254, 254, 254, 1);
        opacity: 0.3;
        text-align: left;
        padding: 0 24px;
        margin-top: 12px;
      }
    }
    .first-theatre {
      margin-left: 0;
    }
  }
}
.strategic {
  height: 550px;
  background-color: #1f1f1f;
  &-left {
    width: 100%;
    color: #fefefe;
    padding-top: 50px;
    box-sizing: border-box;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    &-info {
      width: 600px;
      display: inline-block;
      text-align: center;
      box-sizing: border-box;
      &-title {
        font-size: 40px;
        font-weight: bold;
        margin: 0 auto;
        height: 52px;
        line-height: 52px;
      }
      &-desc {
        font-size: 22px;
        font-weight: 300;
        color: rgba(207, 207, 207, 1);
        line-height: 44px;
        white-space: nowrap;
        &-first {
          margin-top: 28px;
        }
      }
      &-bubble {
        margin-top: 40px;
      }
      &-more {
        width: 232px;
        height: 46px;
        border: 1px solid rgba(236, 105, 0, 1);
        border-radius: 23px;
        color: rgba(236, 105, 0, 1);
        text-align: center;
        line-height: 46px;
        margin-top: 55px;
        vertical-align: middle;
        display: inline-block;
        cursor: pointer;
        &-arrow {
          margin-left: 2px;
          vertical-align: middle;
          font-size: 10px;
        }
      }
    }
  }
  &-right {
    width: 50%;
    display: none;
    height: 100%;
    background-color: #000000;
    display: inline-block;
    vertical-align: middle;
    position: relative;
    &-play {
      position: absolute;
      font-size: 118px;
      color: #fefefe;
      opacity: 0.67;
      left: 50%;
      top: 50%;
      cursor: pointer;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
